export default ({ IDL }) => {
  const UserName_2 = IDL.Text;
  const UserName = UserName_2;
  const UserId_2 = IDL.Principal;
  const Profile_2 = IDL.Record({
    'id' : UserId_2,
    'userName' : UserName_2,
    'move' : IDL.Vec(IDL.Text),
    'name' : IDL.Text,
    'createdAt' : IDL.Int,
    'invitation' : UserName_2,
    'accepted' : IDL.Bool,
  });
  const Profile = Profile_2;
  const UserId = UserId_2;
  const game = IDL.Service({
    'acceptInvite' : IDL.Func([], [IDL.Opt(IDL.Null)], []),
    'checkInvite' : IDL.Func([], [IDL.Opt(UserName)], ['query']),
    'checkNewGame' : IDL.Func([], [IDL.Opt(IDL.Vec(IDL.Text))], ['query']),
    'checkUserName' : IDL.Func([UserName], [IDL.Bool], ['query']),
    'createProfile' : IDL.Func([UserName], [IDL.Opt(IDL.Principal)], []),
    'getMove' : IDL.Func([], [IDL.Opt(IDL.Vec(IDL.Text))], ['query']),
    'getMovep2' : IDL.Func([], [IDL.Opt(IDL.Vec(IDL.Text))], ['query']),
    'getProfile' : IDL.Func([], [IDL.Opt(Profile)], ['query']),
    'getSnakeScore' : IDL.Func([], [IDL.Int], ['query']),
    'getUserName' : IDL.Func([UserId], [IDL.Opt(UserName)], ['query']),
    'inviteStatus' : IDL.Func([], [IDL.Opt(IDL.Bool)], ['query']),
    'makeMove' : IDL.Func([IDL.Vec(IDL.Text)], [IDL.Opt(IDL.Null)], []),
    'makeMovep2' : IDL.Func([IDL.Vec(IDL.Text)], [IDL.Opt(IDL.Null)], []),
    'newGame' : IDL.Func([IDL.Vec(IDL.Text)], [IDL.Opt(IDL.Null)], []),
    'sendInvite' : IDL.Func([UserName, UserName], [IDL.Opt(IDL.Null)], []),
    'setSnakeScore' : IDL.Func([IDL.Int], [], []),
  });
  return game;
};
export const init = ({ IDL }) => { return []; };